//#region IMPORT
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
/** Services Import */
import { useSelector, useDispatch } from 'react-redux';
import { setStartDate, setEndDate } from '../../../../Reducer/SearchReducer';
/** Components */
import { HAM_HAN } from './index';
import { Loading } from '../../../../Components/MUIs';
import dayjs from 'dayjs';
import useCompanyCustDepRedux from '../../../../hooks/useCompanyCustDep';
//#endregion

function HAM_HANF() {
  //#region 변수
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading] = useState(false);
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const [value, setValue] = React.useState(0);
  // 선택된 구분 ID (0 = 전체). 두 탭이 공유
  const [gubunId, setGubunId] = useState(0);

  // 회사/거래처 선택 상태 관리 및 필수 여부 검증을 위한 Hook
  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDepRedux({ requireCompany: true, requireCust: true });

  // 검색 조건에서 사용할 시작일/종료일 상태 관리
  const startDate = searchInfo.startDate;
  const endDate = searchInfo.endDate;

  const handleStartDateChange = (newStart) => {
    const newStartDate = dayjs(newStart).format('YYYY-MM-DD');
    let updatedEnd = searchInfo.endDate;

    // 시작일이 종료일보다 크거나 같으면 종료일도 시작일로 맞춤
    if (!dayjs(newStartDate).isBefore(dayjs(updatedEnd))) {
      updatedEnd = newStartDate;
      dispatch(setEndDate(updatedEnd));
    }

    dispatch(setStartDate(newStartDate));
  };

  const handleEndDateChange = (newEnd) => {
    const newEndDate = dayjs(newEnd).format('YYYY-MM-DD');
    let updatedStart = searchInfo.startDate;

    // 종료일이 시작일보다 빠르면 시작일을 종료일로 맞춤
    if (dayjs(newEndDate).isBefore(dayjs(updatedStart))) {
      updatedStart = newEndDate;
      dispatch(setStartDate(updatedStart));
    }

    dispatch(setEndDate(newEndDate));
  };

  const [filterClick1, setFilterClick1] = useState(false); // 1번탭 버튼 이벤트
  const [searchClick1, setSearchClick1] = useState(false);
  const [addClick1, setAddClick1] = useState(false);
  const [saveClick1, setSaveClick1] = useState(false);
  const [deleteClick1, setDeleteClick1] = useState(false);
  const [printClick1, setPrintClick1] = useState(false);
  const [copyClick1, setCopyClick1] = useState(false);
  const [listClick1, setListClick1] = useState(false);

  const [filterClick2, setFilterClick2] = useState(false); // 2번탭 버튼 이벤트
  const [searchClick2, setSearchClick2] = useState(false);
  const [addClick2, setAddClick2] = useState(false);
  const [saveClick2, setSaveClick2] = useState(false);
  const [deleteClick2, setDeleteClick2] = useState(false);
  const [printClick2, setPrintClick2] = useState(false);
  const [copyClick2, setCopyClick2] = useState(false);
  const [listClick2, setListClick2] = useState(false);
  //#endregion

  // useEffect(() => {
  //   Init();
  // }, []);

  const executed = React.useRef(false);

  useEffect(() => {
    if (!executed.current && searchInfo.custCd) {
      Init();
      executed.current = true; // 다시 실행 안 되게
    }
  }, [searchInfo.custCd]);

  const Init = async () => {
    setSearchClick1(true);
  };

  // 구분 선택 시 현재 탭 재조회
  const handleGubunSelect = (id) => {
    setGubunId(id || 0);
    if (value === 0) setSearchClick1(true);
    else if (value === 1) setSearchClick2(true);
  };

  // 관리감독자 이동 클릭 이벤트
  // 탭 클릭 이벤트
  const handleChange = (event, newValue) => {
    if (newValue === 0) setSearchClick1(true);
    else if (newValue === 1) setSearchClick2(true);

    setValue(newValue);
  };

  //#endregion

  return (
    <div className="wrap">
      <HAM_HAN
        navigate={navigate}
        userInfo={userInfo}
        lanInfo={lanInfo}
        searchInfo={searchInfo}
        value={value}
        gubunId={gubunId}
        handleGubunSelect={handleGubunSelect}
        filterClick1={filterClick1}
        setFilterClick1={setFilterClick1}
        searchClick1={searchClick1}
        setSearchClick1={setSearchClick1}
        addClick1={addClick1}
        setAddClick1={setAddClick1}
        saveClick1={saveClick1}
        setSaveClick1={setSaveClick1}
        deleteClick1={deleteClick1}
        setDeleteClick1={setDeleteClick1}
        printClick1={printClick1}
        setPrintClick1={setPrintClick1}
        copyClick1={copyClick1}
        setCopyClick1={setCopyClick1}
        listClick1={listClick1}
        setListClick1={setListClick1}
        filterClick2={filterClick2}
        setFilterClick2={setFilterClick2}
        searchClick2={searchClick2}
        setSearchClick2={setSearchClick2}
        addClick2={addClick2}
        setAddClick2={setAddClick2}
        saveClick2={saveClick2}
        setSaveClick2={setSaveClick2}
        deleteClick2={deleteClick2}
        setDeleteClick2={setDeleteClick2}
        printClick2={printClick2}
        setPrintClick2={setPrintClick2}
        copyClick2={copyClick2}
        setCopyClick2={setCopyClick2}
        listClick2={listClick2}
        setListClick2={setListClick2}
        // 회사, 사업장 관련 props
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        // 날짜 관련 props
        startDate={startDate}
        endDate={endDate}
        handleStartDateChange={handleStartDateChange}
        handleEndDateChange={handleEndDateChange}
        // 함수
        handleChange={handleChange}
      />
      <Loading open={loading} />
    </div>
  );
}

export default HAM_HANF;
